import { useState } from 'react'

/**
 *
 * Custom hook to manage forms in an easy way.
 *
 * @param {} initialForm
 *
 * @returns {
 *  formState,
 *  onInputChange,
 *  onResetForm
 * }
 */

export const useForm = (initialForm = {}) => {
  const [formState, setFormState] = useState(initialForm)

  const onInputChange = ({ target }) => {
    const { name, value } = target
    setFormState({
      ...formState,
      [name]: value,
    })
  }

  const onResetForm = () => {
    setFormState(initialForm)
  }

  const setFormData = (newFormData) => {
    setFormState({
      ...formState,
      ...newFormData,
    })
  }

  return {...formState, formState, onInputChange, onResetForm, setFormData}
}
